import { cn } from '@heroui/react';
import { ReactNode } from 'react';

export type ContentHeaderActionsProps = {
  className?: string;
  children?: ReactNode;
};

export function ContentHeaderActions(props: ContentHeaderActionsProps) {
  const { className, children } = props;

  return (
    <div className={cn('flex items-center gap-4', className)}>{children}</div>
  );
}
